<ng-container
  *ngIf="{
    isMQ3max: thresholdRange === mediaQueryThreshold.MQ3max,
    isMQ4: thresholdRange === mediaQueryThreshold.MQ4,
    isMQ5min: thresholdRange === mediaQueryThreshold.MQ5min
  } as range"
>
  <!-- HEADER -->
  <cc-header *ngIf="isInStandaloneMode$ | async" />

  <div class="cc-app-container">
    <ng-container *ngIf="!(range.isMQ3max && isRowLayoutUsed)">
      <ng-container *ngTemplateOutlet="headerAnchorLink" />
    </ng-container>

    <!-- MBCC-724: cc-app-container__header is used for height measurement and referenced in global-constants.ts -->
    <div
      class="cc-app-container__header"
      *ngIf="vehicleForUpcomingConfiguration && (isAppContainerHeaderStep$ | async)"
      [class.cc-app-container__header__navigation-open]="navigationIsOpen"
      [class.cc-app-container__header__sticy-on-mobile]="!isRowLayoutUsed"
      [class.cc-app-container__header__drop-shadow]="(isSummary$ | async) && range.isMQ3max"
    >
      <cc-header-info [vehicle]="vehicleForUpcomingConfiguration" [isSummary]="isSummary$ | async" />

      <!-- MOBILE NAVI FOR NON SINGLE OPTION -->
      <ng-container *ngIf="showNavigation && range.isMQ3max && !isRowLayoutUsed">
        <ng-container *ngTemplateOutlet="navigationTemplate" />
      </ng-container>
    </div>

    <!-- MOBILE NAVI FOR SINGLE OPTION -->
    <ng-container *ngIf="showNavigation && range.isMQ3max && isRowLayoutUsed">
      <ng-container *ngTemplateOutlet="headerAnchorLink" />
      <ng-container *ngTemplateOutlet="navigationTemplate; context: { top: '0' }" />
    </ng-container>

    <!-- MAIN  -->
    <div
      class="cc-app-container__main"
      id="{{ appContainerId }}"
      [class.cc-app-container__motorization-or-config-page]="showNavigation"
    >
      <!-- CONTAINER where the background image should apply -->
      <div
        class="cc-app-container__main-frame"
        [class.cc-app-container__main-frame--summary-sidebar-layout]="isSidebarShown$ | async"
        [class.cc-grid-container]="!range.isMQ3max && (isSidebarShown$ | async) === false"
      >
        <!-- NAVI WITH SEARCH -->
        <div
          class="cc-app-container__navigation"
          *ngIf="showNavigation && !range.isMQ3max && (isSidebarShown$ | async) === false"
          [ngStyle]="{ 'top.px': mainContainerTopPosition$ | async }"
        >
          <cc-selectables-search-host *ngIf="!range.isMQ3max" [isMQ3max]="range.isMQ3max" />
          <ng-container *ngTemplateOutlet="navigationTemplate" />
        </div>

        <cc-modal-host />

        <ng-container *ngTemplateOutlet="content" />

        <ng-container *ngIf="vehicleForUpcomingConfiguration as vehicle">
          <div class="cc-app-container__finance-modal" *ngIf="(useFcis$ | async) === true && vehicle">
            <cc-finance-calculator-modal />
          </div>
        </ng-container>

        <!-- NOTE: there is a global spinner already in the app component and a flag in the common store. make use of this instead -->
        <cc-loading-spinner *ngIf="isLoadingReflectingSpinnerState$ | async" />
        <ng-container *ngIf="acknowledgementConfig$ | async as acknowledgementConfig">
          <cc-acknowledgement-container *ngIf="acknowledgementConfig.isActive" />
        </ng-container>
      </div>
    </div>
  </div>

  <!-- FOOTER  -->
  <cc-footer />

  <!-- NAVIGATION -->
  <ng-template #navigationTemplate let-top="top">
    <cc-navigation
      *ngIf="(isSummary$ | async) === false"
      [style.top]="top"
      (isOpenValueChange)="onNavigationIsOpen($event)"
    />
  </ng-template>

  <ng-template #content>
    <!-- content: content projection which is the router-outlet main content -->

    <div
      *ngIf="{ isSticky: isRowLayoutUsed } as props"
      [class.cc-grid-container]="(isSidebarShown$ | async) === false"
      [class.cc-grid-container__single-choice-view]="isSingleChoiceView"
    >
      <div
        class="cc-app-container__content"
        [ngClass]="{
          'cc-grid-container': (isSidebarShown$ | async) === false,
          'cc-app-container__content-row-layout': isRowLayoutUsed && !range.isMQ3max
        }"
      >
        @if (isRowLayoutUsed && !range.isMQ3max) {
          <!-- CONTENT: Single-choice -->
          <ng-container *ngTemplateOutlet="contentLayout"></ng-container>
        }
        <!-- STAGE -->
        <div
          class="cc-app-container__content-stage-container"
          *ngIf="displayStage$ | async"
          #appContainerContentStageContainer
          [id]="idMainContainer"
          [ngStyle]="{ 'top.px': mainContainerTopPosition$ | async, position: props.isSticky ? 'sticky' : 'static' }"
          [class.cc-app-container__content-stage-container--sticky]="props.isSticky"
          [class.cc-app-container__content-stage-container--single-choice-view]="isSingleChoiceView"
        >
          <!-- STAGE -->
          <cc-stage-with-sidebar
            class="cc-app-container__content-main-stage"
            [hasSelectionBoxLeftNextToIt]="isRowLayoutUsed"
            [stickiness]="{
              isSticky: props.isSticky,
              topPosition: mainContainerTopPosition$ | async,
              height: mainContainerHeight
            }"
          />

          <!-- NEXT STEP FOR ROW LAYOUT -->
          <div class="cc-app-container__next-step-button--row-layout" *ngIf="props.isSticky && !range.isMQ3max">
            <ng-container *ngTemplateOutlet="nextButton" />
          </div>
        </div>

        <!-- MBCC-724: anchor for content scroll target | contentScrollAnchorId is used for height measurement and referenced in global-constants.ts -->
        <a class="{{ contentScrollAnchorId }}" id="{{ !isRowLayoutUsed ? contentScrollAnchorId : '' }}"></a>

        @if (!isRowLayoutUsed || range.isMQ3max) {
          <!-- CONTENT: multichoice or summary or motorization -->
          <ng-container *ngTemplateOutlet="contentLayout"></ng-container>
        }

        <!-- NEXT STEP FOR COLUMN LAYOUT -->
        <div
          class="cc-app-container__next-step-button"
          *ngIf="showNavigation && (!isRowLayoutUsed || range.isMQ3max)"
          [class.cc-app-container__next-step-button--single-choice-view]="isSingleChoiceView"
        >
          <ng-container *ngTemplateOutlet="nextButton" />
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<!-- It was separated in a template because single choice steps must come before stage in the dom,
 due to tabindex accessibility -->
<ng-template #contentLayout>
  <div
    #appContainer
    [ngClass]="{
      'cc-app-container__content-row-layout-selectables': isRowLayoutUsed,
      'cc-app-container__content-stage-container--with-margin': (isSidebarShown$ | async) === true
    }"
  >
    <span #scrollIndicatorAnchor></span>
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #headerAnchorLink>
  <a id="{{ headerScrollAnchorId }}" #headerScrollAnchorReference></a>
</ng-template>

<ng-template #nextButton>
  <!-- TODO: MBCC-1288 remove queryParams once new entry points ticket is implemented. Used to skip redirection to vehicleLength via a queryParam -->
  <ng-container *ngrxLet="nextStepButton$ as nextStepButton">
    <ccwb-button
      *ngIf="nextStepButton.showButton"
      (click)="onNextStep(nextStepButton.nextNavigationItem?.routerLink)"
      variant="primary"
      size="l"
      rel="nofollow"
    >
      <ccwb-icon class="next-button-icon" name="bds/chevron-right/24" slot="icon" icon-flip-rtl />
      {{ nextStepButton.nextNavigationItem?.label }}
    </ccwb-button>
  </ng-container>
</ng-template>
